import React, { ReactElement } from 'react';
import { usePerPageValueFromUrl } from 'idsk-react-components';
import { useSearchParams } from 'react-router-dom';
import { MobilePerPageSelect, Pagination, useResponsiveContext } from 'slovlex-idsk-react-components';
import PripomienkaRow from '../PripomienkaRow/PripomienkaRow';
import PripomienkaListPage from '../../../../model/pripomienka/PripomienkaListPage';
import { perPageDataArray } from '../../../../constants/PaginationPerPageConstants';

interface Props {
  pripomienkaListPage: PripomienkaListPage;
  pageNumberFromUrl: number;
  setAssignedList?: (assignedList: Array<string>) => void;
  assignedList?: Array<string>;
  reloadPripomienkaListPage?(): void;
  reloadFilterData?(): void;
  isSelectedFilter: boolean;
}

const PripomienkaListComponent = ({
  pripomienkaListPage, pageNumberFromUrl,
  assignedList, setAssignedList,
  reloadPripomienkaListPage,
  reloadFilterData,
  isSelectedFilter,
}: Props): ReactElement => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray);
  const { isSmallScreen } = useResponsiveContext();

  if (!pripomienkaListPage) {
    return null;
  }

  if (pripomienkaListPage.totalElements === 0 && isSelectedFilter) {
    return (
      <p className="text-center pripomienky-list-message">
        Žiadna z pripomienok nevyhovuje zadaným kritériám.
      </p>
    );
  }

  if (pripomienkaListPage.totalElements === 0) {
    return (
      <p className="text-center pripomienky-list-message">
        K tomuto materiálu neboli doručené žiadne pripomienky.
      </p>
    );
  }

  if (pripomienkaListPage.totalElements > 0 && pripomienkaListPage.pripomienky.length === 0) {
    return (
      <>
        <p className="text-center pripomienky-list-message">
          Na aktuálnej stránke sa nenachádzajú žiadne pripomienky.
        </p>
        <div className="pripomienky-list__pagination">
          <Pagination
            number={pageNumberFromUrl}
            size={pripomienkaListPage.size}
            totalElements={pripomienkaListPage.totalElements}
          />
        </div>
      </>
    );
  }

  return (
    <div className="pripomienky-list">
      {isSmallScreen && (
        <MobilePerPageSelect
          perPageValue={perPageValue}
          onRecordsPerPageChange={(value) => {
            const updatedSearchParams = new URLSearchParams(searchParams.toString());
            updatedSearchParams.set('perPage', value.toString());
            setSearchParams(updatedSearchParams.toString());
          }}
          recordsPerPage={perPageDataArray}
          hideTotal
        />
      )}
      {pripomienkaListPage.pripomienky.map((pripomienka) => (
        <PripomienkaRow
          key={pripomienka.uuid}
          pripomienka={pripomienka}
          assignedList={assignedList}
          setAssignedList={setAssignedList}
          reloadPripomienkaListPage={reloadPripomienkaListPage}
          reloadFilterData={reloadFilterData}
        />
      ))}
      <div className="pripomienky-list__pagination">
        <Pagination
          number={pageNumberFromUrl}
          size={pripomienkaListPage.size}
          totalElements={pripomienkaListPage.totalElements}
          pageQueryName="page"
          onRecordsPerPageChange={(value) => {
            const updatedSearchParams = new URLSearchParams(searchParams.toString());
            updatedSearchParams.set('perPage', value.toString());
            setSearchParams(updatedSearchParams.toString());
          }}
          recordsPerPage={perPageDataArray}
          perPageValue={perPageValue}
        />
      </div>
    </div>
  );
};

export default PripomienkaListComponent;
